import {
    Component,
    EventEmitter,
    Output,
    Input,
    OnInit,
    OnChanges, SimpleChanges, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { PermissionResourceService } from "../../service/resources/permission/permissionResource.service";
import { PricesTableService } from "../booking-information/components/booking-price-card/services/prices-table.service";
import { Subscription } from "rxjs";

export interface IMenuDetails {
    code: string;
    name: string;
    exist: boolean;
    selected: boolean;
    permission?: string;
    minWidth?: string;
}

class Wording {
    public readonly labelTarifications: string = Yii.t('wui-shared-js', 'Affichage de la liste des tarifications');
    public readonly labelPriceArray: string = Yii.t('wui-shared-js', 'Affichage du tableau des prix');
}

export enum DisplayType {
    tarificationsList = 'tarificationsList',
    pricesTable = 'pricesTable',
}

export enum EShowContext {
    table = "table",
    detail = "detail",
    list = "list"
}

@Component({
    selector: 'menu-details-tarifications',
    templateUrl: './menu-details-tarifications.component.html',
    styleUrls: ['./menu-details-tarifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuDetailsTarificationsComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public itemsTarifications: IMenuDetails[];

    @Input()
    public canUse: boolean = true;

    @Input()
    public hasRetailInPayload: boolean = false;

    @Input()
    public rateSelected: boolean;

    @Output()
    public readonly onChangeTab: EventEmitter<string> = new EventEmitter();

    @Output()
    public readonly onShowPricesDetailsChange: EventEmitter<DisplayType> = new EventEmitter();

    @Output()
    public readonly onRemoveSelectedRate: EventEmitter<void> = new EventEmitter();

    public isTableVisible: boolean = true;
    public wording: Wording = new Wording();
    public display: DisplayType = DisplayType.pricesTable;
    public showReturnButton: boolean = false;
    public labelToShow: string;
    public showContext: EShowContext;
    public rateSelectedSubscription: Subscription;

    constructor(
        private readonly permissionService: PermissionResourceService,
        private readonly pricesTableService: PricesTableService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {
    }

    public changeTab(tabCode: string): void {
        if (this.canUse) {
            this.display = tabCode as DisplayType;
            this.onChangeTab.emit(tabCode);
        }
    }

    public ngOnInit(): void {
        this.showContext = EShowContext.table;
        this.labelToShow = this.wording.labelTarifications;

        this.rateSelectedSubscription = this.pricesTableService.rateSelectedSubject.subscribe((rateSelected: string): void => {
            if (rateSelected === null) {
                this.rateSelected = null;
                this.showReturnButton = false;
            } else {
                this.rateSelected = true;
                this.showReturnButton = true;
            }
            this.changeDetectorRef.detectChanges();
        });

        (this.itemsTarifications || []).forEach((item: IMenuDetails): void => {
            if (item.permission) {
                this.permissionService.hasPermission(item.permission)
                    .subscribe((hasPermission: boolean): void => {
                        item.exist = hasPermission;
                    });
            }
        });
    }

    public ngOnDestroy(): void {
        this.rateSelectedSubscription.unsubscribe();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.rateSelected) {
            this.showReturnButton = changes.rateSelected.currentValue;
        }
    }

    public toggleDetails(): void {
        const isTable: boolean = this.showContext === EShowContext.table;
        this.display = isTable ? DisplayType.tarificationsList : DisplayType.pricesTable;
        this.showContext = isTable ? EShowContext.list : EShowContext.table;
        this.labelToShow = isTable ? this.wording.labelPriceArray : this.wording.labelTarifications;
        if (this.rateSelected) {
            this.pricesTableService.removeRateSelected();
        }
        this.onShowPricesDetailsChange.emit(this.display);
        this.changeDetectorRef.detectChanges();
    }
}